import React, { useEffect } from "react";

import { Link } from "react-router-dom";
import ActivityBar from "../../components/Reusable/ActivityBar/ActivityBar";
import { Box, Paper, Typography } from "@mui/material";
import user from "../../assets/images/dummyUser.jpg";
import { apiService } from "../../api/apiService";
import { useMsal } from '@azure/msal-react';
import { PublicClientApplication } from '@azure/msal-browser';


const FeedbackView: React.FC = () => {
  const { instance } = useMsal();

  const [feedbackData, setFeedbackData] = React.useState<any[] | null>(null);
  const breadcrumbs = [
    <Link key="1" color="#000" to="/">
      Home
    </Link>,
    <Link key="2" color="#000" to="/feedback">
      Review and Feedback
    </Link>,
  ];

  useEffect(() => {
    const fetchData = async () => {
      // const body = {
      //   management: localStorage.getItem("apiManagement"),
      // };
      try {
        const data = await apiService("/ops/feedback", "GET", undefined, undefined, instance as PublicClientApplication);
        setFeedbackData(data?.data);
      } catch (error) {
        console.error("Failed to save Vision N Strategy:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <ActivityBar breadcrumbs={breadcrumbs} />

      <Box style={{ padding: "20px" }}>
        <Typography sx={{ fontSize: "18px", fontWeight: "600", color: "#000", }}>Review and Feedback</Typography>
      </Box>

      {feedbackData && feedbackData.length>0? feedbackData.map((item, index) => (
        <Paper key={index} sx={{ maWwidth: "100%", height: "auto", borderRadius: "10px", padding: "20px", marginBottom: "20px", marginLeft: '20px', }} elevation={3}>
          <Box sx={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
            <Box sx={{ display: "flex", gap: "10px" }}>
              <img src={user} height="50px" />
              <Typography sx={{ fontSize: "16px", fontWeight: "600", display: "flex", flexFlow: 'column', alignItems: "center", justifyContent: "center", color: "#000", height: "50px" }}>
                {item?.user_name}
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ fontSize: "16px", fontWeight: "600", color: '#1e1e1ea3' }}>
                {new Date(item?.updated_at).toLocaleDateString('en-GB')}
              </Typography>
            </Box>
          </Box>
          <Box width="auto" sx={{ backgroundColor: "#D4D4D5", height: "1px", my: 0 }} />
          <Box sx={{ display: "flex", justifyContent: "space-between", padding: "10px" }}>
            <Typography sx={{ fontSize: "14px" }}>{item?.feedback}</Typography>
            <Typography>{item?.rating}/10</Typography>
          </Box>
        </Paper>)): <Typography sx={{margin:'0px 10px'}}>Loading...</Typography>}
    </>
  )

};
export default FeedbackView;